import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./tokens.css";
import "./styles/base.css";
import "./styles/type.css";
import "./styles/components.css";
import "./styles/screens.css";
import "./styles/landscape.css";
import { App } from "./App";
import { trackViewportHeight } from "./lib/viewport";
import { startNative } from "./lib/native";
import { listenForInstall } from "./lib/install";

trackViewportHeight();
listenForInstall();
void startNative();

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
